import { render } from "./VisionPlan.vue?vue&type=template&id=3b69aaf4"
import script from "./VisionPlan.vue?vue&type=script&lang=js"
export * from "./VisionPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__